import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
// import { feeGroup, feesTypes, paymentType } from '../../../core/common/selectoption/selectoption'
import { DatePicker } from "antd";
import dayjs from "dayjs";
import { all_routes } from "../../../router/all_routes";
import {

  Contract,
  Marital,
  Shift,
  allClass,
  allSubject,
  classSection,
  gender_data,
  status_data,
} from "../../../../core/common/selectoption/selectoption";
import { TagsInput } from "react-tag-input-component";
import CommonSelect from "../../../../core/common/commonSelect";
import { useLocation } from "react-router-dom";
import axios from "axios";
import Select, {SingleValue} from "react-select";
interface TeacherType {
    teacher_uid: number;
    teacher_id: number;
    first_name: string;
    last_name: string;
    full_name: string;
    status: string;
    email: string;
    contact_no: string;
    // Define additional properties...
}


const TeacherForm = () => {
  const routes = all_routes;

  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [defaultDate, setDefaultDate] = useState<dayjs.Dayjs | null>(null);
  const [newContents, setNewContents] = useState<number[]>([0]);
  const location = useLocation();

  const [teacher_id, setTeacherId] = useState('');
  const [first_name, setFirstName] = useState('');
  const [last_name, setLastName] = useState('');
  const [full_name, setFullName] = useState('');
  const [username, setUserName] = useState('');
  const [gender, setGender] = useState('');
  const [nric, setNric] = useState('');
  const [passport, setPassport] = useState('');
  const [contact_no, setContactNo] = useState('');
  const [email, setEmail] = useState('');
  const [father_name, setFatherName] = useState('');
  const [mother_name, setMotherName] = useState('');
  const [dob, setDob] = useState<Date | null>(null);
  const [marriage_status, setMarriageStatus] = useState('');
  const [language_known, setLanguage] = useState<string[]>(['English', 'Tamil', 'Malay']);
  const [subjects, setSubjects] = useState('');
  const [classes, setClasses] = useState('');
  const [sections, setSections] = useState('');
  const [qualification, setQualification] = useState('');
  const [permanent_address, setPermanentAddress] = useState('');
  const [current_address, setCurrentAddress] = useState('');
  const [status, setStatus] = useState('');
  const [note, setNote] = useState('');
  const [selectedDate, setSelectedDate] = useState(null);
  const [doj, setDoj] = useState<Date | null>(null);
  const [editData, setEditData] = useState<TeacherType[]>([]);


  const handleGenderChange = (selectedOption: SingleValue<{ value: string; label: string }>) => {
    setGender(selectedOption ? selectedOption.value : '');
  };

  const handleStatusChange = (selectedOption: SingleValue<{ value: string; label: string }>) => {
    setStatus(selectedOption ? selectedOption.value : '');
  };
  const handleMaritalChange = (selectedOption: SingleValue<{ value: string; label: string }>) => {
    setMarriageStatus(selectedOption ? selectedOption.value : '');
  };
  const handleLanguageChange = (newTags: string[]) => {
    setLanguage(newTags);
    console.log("Languages Known:", newTags);
  };
    const handleSubjectChange = (selectedOptions: any) => {
        const selectedSubjects = selectedOptions ? selectedOptions.map((option: any) => option.value) : [];
        setSubjects(selectedSubjects.join(','));
    };
    const handleSectionChange = (selectedOptions: any) => {
        const selectedSection = selectedOptions ? selectedOptions.map((option: any) => option.value) : [];
        setSections(selectedSection.join(','));
    };
    const handleClassChange = (selectedOptions: any) => {
        const selectedClass = selectedOptions ? selectedOptions.map((option: any) => option.value) : [];
        setClasses(selectedClass.join(','));
    };

    const queryParams = new URLSearchParams(location.search); // Extract the query string from the current URL
    const id = queryParams.get('teacher_id');
    const fetchTeacher = async () => {
            const response = await fetch(`/api/teacher/getTeacher/${id}`);
            const teachers: TeacherType[] = await response.json();
            setEditData(teachers);
    }

  useEffect(() => {
    if (location.pathname === routes.editTeacher) {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, "0"); // Month is zero-based, so we add 1
      const day = String(today.getDate()).padStart(2, "0");
      const formattedDate = `${month}-${day}-${year}`;
      const defaultValue = dayjs(formattedDate);
      setDefaultDate(defaultValue);
      setIsEdit(true);
      fetchTeacher();
      console.log(formattedDate, 11);
    } else {
      setIsEdit(false);
      setDefaultDate(null);
    }
  }, [location.pathname]);

  const handleDateChange = (date: Date | null, fieldName: string) => {
    if (fieldName === 'doj') {
      if (date) {
        console.log(`${fieldName} Formatted Date:`, dayjs(date).format('YYYY-MM-DD'));
      } else {
        console.log(`${fieldName} Formatted Date: null`);
      }
    }
  };

  const teacherSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
     const teacherResponse = await axios.post('/api/teacher/addTeacher', [{
        teacher_id, first_name, last_name, full_name,username, gender, nric, passport, contact_no, email, father_name, mother_name, dob, marriage_status,
        language_known,qualification,permanent_address,current_address,status,note,subjects, classes, sections,
        /*, nric, passport, contact_no,email,father_name,mother_name,date_of_birth,marriage_status,language_known,qualification,permanent_address,current_address,status,experience_uid,note,image_url,create_by,update_by,create_date,update_date */
      }]);
      if (teacherResponse.status === 200 || teacherResponse.status === 201) {
       alert('Teacher added successfully');
        console.log("welcome to added new Teacher");
        console.log("Teacher Data:", {
              teacher_id,
              first_name,
              last_name,
              full_name,
              username,
              gender
              , nric, passport, contact_no, email, father_name, mother_name, dob, marriage_status,
              language_known, qualification, permanent_address, current_address, status, note, subjects, classes, sections,
            }
        );
      }else {
        alert('Teacher added failed!');
      }
    } catch (error) {
      console.log(error);
    }
  };


  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content content-two">
          {/* Page Header */}
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <div className="my-auto mb-2">
              <h3 className="mb-1">{isEdit ? "Edit" : "Add"} Teacher</h3>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to={routes.teacherList}>Teacher</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    {isEdit ? "Edit" : "Add"} Teacher
                  </li>
                </ol>
              </nav>
            </div>
          </div>
          {/* /Page Header */}
          <div className="row">
            <div className="col-md-12">
              <form onSubmit={teacherSubmit}>
                <>
                  {/* Personal Information */}
                  <div className="card">
                    <div className="card-header bg-light">
                      <div className="d-flex align-items-center">
                        <span className="bg-white avatar avatar-sm me-2 text-gray-7 flex-shrink-0">
                          <i className="ti ti-info-square-rounded fs-16" />
                        </span>
                        <h4 className="text-dark">Personal Information</h4>
                      </div>
                    </div>
                    <div className="card-body pb-1">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="d-flex align-items-center flex-wrap row-gap-3 mb-3">
                            <div className="d-flex align-items-center justify-content-center avatar avatar-xxl border border-dashed me-2 flex-shrink-0 text-dark frames">
                              <i className="ti ti-photo-plus fs-16" />
                            </div>
                            <div className="profile-upload">
                              <div className="profile-uploader d-flex align-items-center">
                                <div className="drag-upload-btn mb-3">
                                  Upload
                                  <input
                                    type="file"
                                    className="form-control image-sign"
                                    multiple
                                  />
                                </div>
                                <Link
                                  to="#"
                                  className="btn btn-primary mb-3"
                                >
                                  Remove
                                </Link>
                              </div>
                              <p className="fs-12">
                                Upload image size 4MB, Format JPG, PNG, SVG
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row row-cols-xxl-5 row-cols-md-6">
                        <div className="col-xxl col-xl-3 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Teacher ID</label>
                            <input
                                type="text"
                                value={teacher_id} onChange={(e) => {
                              setTeacherId(e.target.value);
                            }}
                                className="form-control"
                                defaultValue={isEdit ? editData[0].teacher_id : undefined}
                                required
                            />
                          </div>
                        </div>
                        <div className="col-xxl col-xl-3 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">First Name</label>
                            <input
                                type="text"
                                className="form-control"
                                value={first_name} onChange={(e) => {
                              setFirstName(e.target.value);
                            }}
                                defaultValue={isEdit ? "Teresa" : undefined}
                            />
                          </div>
                        </div>
                        <div className="col-xxl col-xl-3 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Last Name</label>
                            <input type="text"
                                   value={last_name} onChange={(e) => {
                              setLastName(e.target.value);
                            }} className="form-control"/>
                          </div>
                        </div>
                        <div className="col-xxl col-xl-3 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Full Name</label>
                            <input type="text" value={full_name} onChange={(e) => {
                              setFullName(e.target.value);
                            }} className="form-control"/>
                          </div>
                        </div>
                        <div className="col-xxl col-xl-3 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">User Name</label>
                            <input type="text" value={username} onChange={(e) => {
                              setUserName(e.target.value);
                            }} className="form-control"/>
                          </div>
                        </div>
                        <div className="col-xxl col-xl-3 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Class</label>
                              <Select
                                  classNamePrefix="react-select"
                                  options={allClass}
                                  className="select2"
                                  isMulti={true}
                                  placeholder="Select class"
                                  onChange={handleClassChange}
                              />
                          </div>
                        </div>
                          <div className="col-xxl col-xl-3 col-md-6">
                              <div className="mb-3">
                                  <label className="form-label">Sections</label>
                                  <Select
                                      classNamePrefix="react-select"
                                      options={classSection}
                                      className="select2"
                                      isMulti={true}
                                      placeholder="Select class"
                                      onChange={handleSectionChange}
                                  />
                              </div>
                          </div>

                        <div className="col-xxl col-xl-3 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Subject</label>
                              <Select
                                  classNamePrefix="react-select"
                                  className="select2"
                                  isMulti={true}
                                  placeholder="Select subjects"
                                  options={allSubject}
                                  onChange={handleSubjectChange}
                              />
                          </div>
                        </div>
                        <div className="col-xxl col-xl-3 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Gender</label>
                            <Select
                                className="select"
                                options={gender_data}
                                defaultValue={isEdit ? gender_data[0] : undefined}
                                value={gender_data.find(option => option.value === gender)}
                                onChange={handleGenderChange}
                            />
                          </div>
                        </div>
                        <div className="col-xxl col-xl-3 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">
                              NRIC/Passport
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                value={nric} onChange={(e) => {
                              setNric(e.target.value);
                            }}
                                defaultValue={
                                  isEdit ? "+601 46548 84498" : undefined
                                }
                            />
                          </div>
                        </div>
                        <div className="col-xxl col-xl-3 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Primary Contact Number
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                value={contact_no} onChange={(e) => {
                              setContactNo(e.target.value);
                            }}
                                defaultValue={
                                  isEdit ? "+601 46548 84498" : undefined
                                }
                            />
                          </div>
                        </div>
                        <div className="col-xxl col-xl-3 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Email Address</label>
                            <input
                                type="email"
                                className="form-control"
                                value={email} onChange={(e) => {
                              setEmail(e.target.value);
                            }}
                                defaultValue={
                                  isEdit ? "jan@example.com" : undefined
                                }
                            />
                          </div>
                        </div>
                        {/*    <div className="col-xxl col-xl-3 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Blood Group</label>
                            <Select
                                className="select"
                                options={bloodGroup}
                                defaultValue={isEdit ? bloodGroup[0] : undefined}
                                value={bloodGroup.find(option => option.value === bloodGroup)}
                                onChange={handleGenderChange}
                            />
                          </div>
                        </div>*/}
                        <div className="col-xxl col-xl-3 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Date of Joining</label>
                            <div className="input-icon position-relative">
                            <DatePicker
                                  className="form-control datetimepicker"
                                  placeholder="Select Date"
                              />
                              <span className="input-icon-addon">
                                <i className="ti ti-calendar"/>
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="col-xxl col-xl-3 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Father’s Name</label>
                            <input
                                type="text"
                                className="form-control"
                                value={father_name} onChange={(e) => {
                              setFatherName(e.target.value);
                            }}
                                defaultValue={
                                  isEdit ? "Francis Saviour" : undefined
                                }
                            />
                          </div>
                        </div>
                        <div className="col-xxl col-xl-3 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Mother’s Name</label>
                            <input
                                type="text"
                                className="form-control"
                                value={mother_name} onChange={(e) => {
                              setMotherName(e.target.value);
                            }}
                                defaultValue={isEdit ? "Stella Bruce" : undefined}
                            />
                          </div>
                        </div>
                        <div className="col-xxl col-xl-3 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Date of Birth</label>
                            <div className="input-icon position-relative">
                              <DatePicker
                                  className="form-control datetimepicker"
                                  value={dob} // use state value
                                  onChange={(date) => handleDateChange(date, 'dob')}
                                  format={{
                                    format: "DD-MM-YYYY",
                                    type: "mask",
                                  }}
                                  placeholder="Select Date"
                              />
                              {/*{isEdit ? <DatePicker
                                  className="form-control datetimepicker"
                                  format={{
                                    format: "DD-MM-YYYY",
                                    type: "mask",
                                  }}
                                  value={defaultDate}
                                  placeholder="Select Date"
                              /> : <DatePicker
                                  className="form-control datetimepicker"
                                  format={{
                                    format: "DD-MM-YYYY",
                                    type: "mask",
                                  }}
                                  defaultValue=""
                                  placeholder="Select Date"
                              />}*/}

                              <span className="input-icon-addon">
                                <i className="ti ti-calendar"/>
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="col-xxl col-xl-3 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Marital Status</label>
                            <Select
                                className="select"
                                options={Marital}
                                defaultValue={isEdit ? Marital[0] : undefined}
                                value={Marital.find(option => option.value === marriage_status)}
                                onChange={handleMaritalChange}
                            />
                          </div>
                        </div>
                        <div className="col-xxl col-xl-3 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Language Known</label>
                            <TagsInput
                                value={language_known}
                                onChange={handleLanguageChange}
                                placeHolder="Enter languages"
                            />
                          </div>
                        </div>
                        <div className="col-xxl col-xl-3 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Qualification</label>
                            <input
                                type="text"
                                className="form-control"
                                onChange={(e) => {
                                  setQualification(e.target.value);
                                }}
                                defaultValue={isEdit ? "MBA" : undefined}
                            />
                          </div>
                        </div>
                        <div className="col-xxl col-xl-3 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Work Experience
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                defaultValue={isEdit ? "2  Years" : undefined}
                            />
                          </div>
                        </div>
                        <div className="col-xxl col-xl-3 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Previous School if Any
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                defaultValue={
                                  isEdit ? "Oxford Matriculation, Malaysia" : undefined
                                }
                            />
                          </div>
                        </div>
                        <div className="col-xxl col-xl-3 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Previous School Address
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                defaultValue={
                                  isEdit
                                      ? "1852 Barnes Avenue, Cincinnati, OH 45202"
                                      : undefined
                                }
                            />
                          </div>
                        </div>
                        <div className="col-xxl col-xl-3 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Previous School Phone No
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                defaultValue={
                                  isEdit ? "+1 35676 45556" : undefined
                                }
                            />
                          </div>
                        </div>
                        <div className="col-xxl col-xl-3 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Address</label>
                            <input
                                type="text"
                                className="form-control"
                                defaultValue={
                                  isEdit
                                      ? "Jalan 1a, Taman Bukit Segar, 56100 Kuala Lumpur"
                                      : undefined
                                }
                                onChange={(e) => {
                                  setCurrentAddress(e.target.value);
                                }}
                            />
                          </div>
                        </div>
                        <div className="col-xxl col-xl-3 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Permanent Address
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                defaultValue={
                                  isEdit
                                      ? "Jalan 1a, Taman Bukit Segar, 56100 Kuala Lumpur"
                                      : undefined
                                }
                                onChange={(e) => {
                                  setPermanentAddress(e.target.value);
                                }}
                            />
                          </div>
                        </div>
                        <div className="col-xxl col-xl-3 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Status</label>
                            <Select
                                className="select"
                                options={status_data}
                                defaultValue={isEdit ? status_data[0] : undefined}
                                value={status_data.find(option => option.value === status)}
                                onChange={handleStatusChange}
                            />
                          </div>
                        </div>
                        <div className="col-xxl-12 col-xl-12">
                          <div className="mb-3">
                            <label className="form-label">Notes</label>
                            <textarea
                                className="form-control"
                                placeholder="Other Information"
                                rows={4}

                                defaultValue={
                                  isEdit
                                      ? "Depending on the specific needs of your organization or system, additional information may be collected or tracked. Its important to ensure that any data collected complies with privacy regulations and policies to protect students sensitive information"
                                      : undefined
                                }
                                onChange={(e) => {
                                  setNote(e.target.value);
                                }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* /Personal Information */}
                </>

                <>
                  {/* Payroll */}
                  <div className="card">
                    <div className="card-header bg-light">
                      <div className="d-flex align-items-center">
                        <span className="bg-white avatar avatar-sm me-2 text-gray-7 flex-shrink-0">
                          <i className="ti ti-user-shield fs-16"/>
                        </span>
                        <h4 className="text-dark">Payroll</h4>
                      </div>
                    </div>
                    <div className="card-body pb-1">
                      <div className="row">
                        <div className="col-lg-4 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">EPF No</label>
                            <input
                                type="text"
                                className="form-control"
                                defaultValue={isEdit ? "34234345" : undefined}
                            />
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Basic Salary</label>
                            <input
                              type="text"
                              className="form-control"
                              defaultValue={isEdit ? "150000" : undefined}
                            />
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Contract Type</label>
                            <CommonSelect
                              className="select"
                              options={Contract}
                              defaultValue={isEdit ? Contract[0] : undefined}
                            />
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Work Shift</label>
                            <CommonSelect
                              className="select"
                              options={Shift}
                              defaultValue={isEdit ? Shift[0] : undefined}
                            />
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Work Location</label>
                            <input
                              type="text"
                              className="form-control"
                              defaultValue={isEdit ? "2nd Floor" : undefined}
                            />
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Date of Leaving
                            </label>
                            <div className="input-icon position-relative">
                            {isEdit? <DatePicker
                                className="form-control datetimepicker"
                                format={{
                                  format: "DD-MM-YYYY",
                                  type: "mask",
                                }}
                                value={defaultDate}
                                placeholder="Select Date"
                              /> : <DatePicker
                              className="form-control datetimepicker"
                              format={{
                                format: "DD-MM-YYYY",
                                type: "mask",
                              }}
                              defaultValue=""
                              placeholder="Select Date"
                            />}
                              <span className="input-icon-addon">
                                <i className="ti ti-calendar" />
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* /Payroll */}
                  {/* Leaves */}
                  <div className="card">
                    <div className="card-header bg-light">
                      <div className="d-flex align-items-center">
                        <span className="bg-white avatar avatar-sm me-2 text-gray-7 flex-shrink-0">
                          <i className="ti ti-users fs-16" />
                        </span>
                        <h4 className="text-dark">Leaves</h4>
                      </div>
                    </div>
                    <div className="card-body pb-1">
                      <div className="row">
                        <div className="col-lg-3 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Medical Leaves</label>
                            <input
                              type="text"
                              className="form-control"
                              defaultValue={isEdit ? "01" : undefined}
                            />
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Casual Leaves</label>
                            <input
                              type="text"
                              className="form-control"
                              defaultValue={isEdit ? "02" : undefined}
                            />
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Maternity Leaves
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              defaultValue={isEdit ? "20" : undefined}
                            />
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Sick Leaves</label>
                            <input
                              type="text"
                              className="form-control"
                              defaultValue={isEdit ? "02" : undefined}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* /Leaves */}
                  {/* Bank Details */}
                  <div className="card">
                    <div className="card-header bg-light">
                      <div className="d-flex align-items-center">
                        <span className="bg-white avatar avatar-sm me-2 text-gray-7 flex-shrink-0">
                          <i className="ti ti-map fs-16" />
                        </span>
                        <h4 className="text-dark">Bank Account Detail</h4>
                      </div>
                    </div>
                    <div className="card-body pb-1">
                      <div className="row">
                        <div className="col-lg-4 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Account Name</label>
                            <input
                              type="text"
                              className="form-control"
                              defaultValue={isEdit ? "Teresa" : undefined}
                            />
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Account Number</label>
                            <input
                              type="text"
                              className="form-control"
                              defaultValue={isEdit ? "0126784900" : undefined}
                            />
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Bank Name</label>
                            <input
                              type="text"
                              className="form-control"
                              defaultValue={
                                isEdit ? "CIMB Clicks" : undefined
                              }
                            />
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">IFSC Code</label>
                            <input
                              type="text"
                              className="form-control"
                              defaultValue={isEdit ? "BOA83209832" : undefined}
                            />
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Branch Name</label>
                            <input
                              type="text"
                              className="form-control"
                              defaultValue={isEdit ? "Cincinnati" : undefined}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* /Bank Details */}
                </>
                <>
                  {/* Social Media Links */}
                  <div className="card">
                    <div className="card-header bg-light">
                      <div className="d-flex align-items-center">
                        <span className="bg-white avatar avatar-sm me-2 text-gray-7 flex-shrink-0">
                          <i className="ti ti-building fs-16" />
                        </span>
                        <h4 className="text-dark">Social Media Links</h4>
                      </div>
                    </div>
                    <div className="card-body pb-1">
                      <div className="row rows-cols-xxl-5">
                        <div className="col-xxl col-xl-3 col-lg-4 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Facebook</label>
                            <input
                              type="text"
                              className="form-control"
                              defaultValue={
                                isEdit ? "www.facebook.com" : undefined
                              }
                            />
                          </div>
                        </div>
                        <div className="col-xxl col-xl-3 col-lg-4 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Instagram</label>
                            <input
                              type="text"
                              className="form-control"
                              defaultValue={
                                isEdit ? "www.instagram.com" : undefined
                              }
                            />
                          </div>
                        </div>
                        <div className="col-xxl col-xl-3 col-lg-4 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Linked In</label>
                            <input
                              type="text"
                              className="form-control"
                              defaultValue={
                                isEdit ? "www.Linkedin.com" : undefined
                              }
                            />
                          </div>
                        </div>
                        <div className="col-xxl col-xl-3 col-lg-4 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Youtube</label>
                            <input
                              type="text"
                              className="form-control"
                              defaultValue={
                                isEdit ? "www.youtube.com" : undefined
                              }
                            />
                          </div>
                        </div>
                        <div className="col-xxl col-xl-3 col-lg-4 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Twitter URL</label>
                            <input
                              type="text"
                              className="form-control"
                              defaultValue={
                                isEdit ? "www.twitter.com" : undefined
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* /Social Media Links */}
                  {/* Documents */}
                  <div className="card">
                    <div className="card-header bg-light">
                      <div className="d-flex align-items-center">
                        <span className="bg-white avatar avatar-sm me-2 text-gray-7 flex-shrink-0">
                          <i className="ti ti-file fs-16" />
                        </span>
                        <h4 className="text-dark">Documents</h4>
                      </div>
                    </div>
                    <div className="card-body pb-1">
                      <div className="row">
                        <div className="col-lg-6">
                          <div className="mb-2">
                            <div className="mb-3">
                              <label className="form-label">
                                Upload Resume
                              </label>
                              <p>
                                Upload image size of 4MB, Accepted Format PDF
                              </p>
                            </div>
                            <div className="d-flex align-items-center flex-wrap">
                              <div className="btn btn-primary drag-upload-btn mb-2 me-2">
                                <i className="ti ti-file-upload me-1" />
                                Change
                                <input
                                  type="file"
                                  className="form-control image_sign"
                                  multiple
                                />
                              </div>
                              <p className="mb-2">Resume.pdf</p>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="mb-2">
                            <div className="mb-3">
                              <label className="form-label">
                                Upload Joining Letter
                              </label>
                              <p>
                                Upload image size of 4MB, Accepted Format PDF
                              </p>
                            </div>
                            <div className="d-flex align-items-center flex-wrap">
                              <div className="btn btn-primary drag-upload-btn mb-2 me-2">
                                <i className="ti ti-file-upload me-1" />
                                Upload Document
                                <input
                                  type="file"
                                  className="form-control image_sign"
                                  multiple
                                />
                              </div>
                              <p className="mb-2">Resume.pdf</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* /Documents */}
                  {/* Password */}
                  <div className="card">
                    <div className="card-header bg-light">
                      <div className="d-flex align-items-center">
                        <span className="bg-white avatar avatar-sm me-2 text-gray-7 flex-shrink-0">
                          <i className="ti ti-file fs-16" />
                        </span>
                        <h4 className="text-dark">Password</h4>
                      </div>
                    </div>
                    <div className="card-body pb-1">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">New Password</label>
                            <input type="password" className="form-control" />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Confirm Password
                            </label>
                            <input type="password" className="form-control" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* /Password */}
                </>

                <div className="text-end">
                  <button type="button" className="btn btn-light me-3">
                    Cancel
                  </button>
                  <button type="submit" className="btn btn-primary">
                    Add Teacher
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* /Page Wrapper */}
    </>
  );
};

export default TeacherForm;